import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

import clsx from 'clsx'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Keyboard } from 'swiper'
import useResponsive from 'utils/useResponsive'

import Supplier from 'assets/image/about-us/work-with-us/supplier.png'
import Career from 'assets/image/about-us/work-with-us/career.png'

const works = [
  {
    img: Supplier,
    title: 'Supplier Opportunities',
    link: 'https://google.com'
  },
  {
    img: Career,
    title: 'Career Opportunities',
    link: 'https://twitter.com'
  },
  {
    img: Supplier,
    title: 'Supplier Opportunities',
    link: 'https://google.com'
  },
  {
    img: Career,
    title: 'Career Opportunities',
    link: 'https://twitter.com'
  }
]

const WorkWithUs = () => {
  const [activeIndex, setActiveIndex] = useState(15)
  const [nextNavTestimoniIsHover, setNextNavTestimoniHover] = useState(false)
  const [prevNavTestimoniIsHover, setPrevNavTestimoniHover] = useState(false)

  const { md } = useResponsive()

  return (
    <section className="md:flex items-center pt-10 pb-20 lg:py-20 xl:py-[88px] max-w-[1440px] m-auto">
      <div className="px-6 md:pl-[24px] lg:px-14 xl:pl-[120px] md:pr-[70px] md:w-[335px] lg:w-[450px] xl:w-[535px]">
        <div className="">
          <Pattern className="w-11 h-11 lg:w-16 lg:h-16 md:w-[72px] md:h-[72px] mb-[24px]" />
          <h1 className="h4-bold xl:h3-bold w-[196px] sm:w-full text-[#101838] md:m-auto left-0 right-0">
            Work With Us
          </h1>
          <p className="text-m-reguler mt-2 lg:mt-4 xl:mt-6 text-[#969FB6]">
            If you are going to use a passage of Lorem Ipsum, you need to be
            sure there isn&apos;t anything embarrassing hidden in the middle of
            text.
          </p>
        </div>

        <div className="flex gap-x-4 mt-[40px]">
          <button
            className={clsx(
              'border border-neutral-50 rounded-[100%] p-3 prev-workwithus',
              'hover:bg-primary-main hover:border-primary-main'
            )}
            onMouseEnter={() => setPrevNavTestimoniHover(true)}
            onMouseLeave={() => setPrevNavTestimoniHover(false)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.9998 19.9201L8.47984 13.4001C7.70984 12.6301 7.70984 11.3701 8.47984 10.6001L14.9998 4.08008"
                stroke={prevNavTestimoniIsHover ? 'white' : '#101838'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <button
            className={clsx(
              'border border-neutral-50 rounded-[100%] p-3 next-workwithus',
              'hover:bg-primary-main hover:border-primary-main'
            )}
            onMouseEnter={() => setNextNavTestimoniHover(true)}
            onMouseLeave={() => setNextNavTestimoniHover(false)}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008"
                stroke={nextNavTestimoniIsHover ? 'white' : '#101838'}
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <div className="relative flex-1 flex overflow-hidden bg-[#F7F8FA] rounded-l-3xl p-[48px] px-0 md:pl-[48px] md:h-[582px] md:mt-0 mt-[40px]">
        <div
          className={clsx(
            'md:hidden bg-[#F7F8FA] h-[120px]',
            activeIndex === 4 ? 'w-[40px]' : 'w-0'
          )}
          style={{
            transitionProperty: 'all',
            transitionDuration: '0.5s',
            transitionTimingFunction: 'ease'
          }}
        />
        <Swiper
          id="work-with-us-swiper"
          className="h-full flex-1"
          spaceBetween={md ? 32 : 16}
          slidesPerView="auto"
          onSlideChange={(swiper) => {
            setActiveIndex(swiper.activeIndex)
            console.log(swiper.activeIndex)
          }}
          onSwiper={(swiper) => {
            setActiveIndex(swiper.activeIndex)
            swiper.slideTo(0, 0)
            console.log(swiper)
          }}
          cssMode={true}
          navigation={{
            prevEl: '.prev-workwithus',
            nextEl: '.next-workwithus',
            clickable: true
          }}
          mousewheel={false}
          keyboard={true}
          modules={[Navigation, Keyboard]}
          loop={true}
        >
          {works.map(({ img, title, link }, index) => {
            return (
              <SwiperSlide
                key={index}
                className="rounded-xl overflow-hidden bg-white max-w-[300px] md:max-w-[270px] lg:max-w-[380px] h-full flex flex-col"
              >
                <img
                  src={img}
                  className="object-cover h-[320px] md:h-[360px]"
                />
                <div className="flex-1 p-[32px]">
                  <h4 className="text-neutral-100 font-medium text-xl mb-[8px]">
                    {title}
                  </h4>
                  <a
                    target="_blank"
                    href='https://api.whatsapp.com/send?phone=6281112588989'
                    className="text-base text-[#003DA6] hover:underline" rel="noreferrer"
                  >
                    Learn More
                  </a>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </section>
  )
}
const Pattern = ({ className }) => {
  return (
    <svg
      className={className}
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" fill="#003DA6" />
      <rect x="48" y="48" width="24" height="24" fill="#DEE9FF" />
    </svg>
  )
}

Pattern.propTypes = {
  className: PropTypes.string
}

export default WorkWithUs
